import { render, staticRenderFns } from "./Step4ProductsDialog.vue?vue&type=template&id=dafd25f4&scoped=true"
import script from "./Step4ProductsDialog.vue?vue&type=script&lang=js"
export * from "./Step4ProductsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafd25f4",
  null
  
)

export default component.exports